/**
 * 任务
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/25      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import Lang from "@components/Lang/Lang";
import "./index.less";
import dayjs from "dayjs";
import { loadImage } from "@utils/image-func";
class Item extends React.Component{
    constructor(props) {
        super(props);
    }

    openDetail(item){
        window.open(`/customer/fuzzy-task-detail?id=${item.id}`,'_self');
    }

    getStatusHtml(item){
        if(item.status=='15'){
            return <div className="status-label status-label15">
                {__getServerLanguage('ZhaoYangZhong')}
            </div>
        }else if(item.status=='20'){
            return <div className="status-label status-label20">
                {__getServerLanguage('YouZhaoDao')}
            </div>
        }else if(item.status=='50'){
            return <div className="status-label status-label50">
                {__getServerLanguage('RenWuWanCheng')}
            </div>
        }else if(item.status=='40'){
            return <div className="status-label status-label40">
                {__getServerLanguage('YiQuXiao')}
            </div>
        }
        return null;
    }

    getMessageTipHtml(item){
        if(!item.messageCount){
            return <div className="color066 font_14 lineH_150p mb_4">{Lang({id:'KeHuMeiYouLiuYan',default:'客户没有留言'})}</div>
        }else{
            if(item.isNewMessage){
                return <div className="color_FB7321 font_14 lineH_150p mb_4">{Lang({id:'KeHuYouXinLiuYanQingLiuYi',default:'客户有新留言，请留意！！'})}</div>
            }else{
                return <div className="color_FB7321 font_14 lineH_150p mb_4">{Lang({id:'KeHuYouLiuYan',default:'客户有留言'})}</div>
            }
        }
    }

    getFooterHtml(item){
        const {extra={}} = this.props;
        if(this.props.tabType==11){
            return <div>
                {this.getStatusHtml(item)}
                {
                    (item.status!=='40'&&item.status!=='50')?
                        <div className={`status-label status-time ml_8 danger`}>
                            <i className="ri-time-line mr_4"></i>
                            {/*距离发布已等待 {item.remainderDays||'0'} 天*/}
                            <span>{__getServerLanguage('JuLiFaBuYiDengDaiTian',item.remainderDays||'0')}</span>
                        </div>:
                        null
                }
            </div>
        }else{
            return <div className="task-footer__wrap">
                {this.getMessageTipHtml(item)}
                <div className="color066 font_14 lineH_150p mb_4">
                    {/*找到 {item.skuNum||0} 款，客户加购 {item.addCartSkuNum||0} 款*/}
                    {__getServerLanguage('ZhaoDaoKuanKeHuJiaGouKuan',item.skuNum||0,item.addCartSkuNum||0)}
                </div>
                <div>
                    {this.getStatusHtml(item)}
                    {
                        (item.status!=='40'&&item.status!=='50')?
                            <div className={`status-label status-time ml_8 ${item.remainderDays<extra.warnDays?'danger':''}`}>
                                <i className="ri-time-line mr_4"></i>
                                <span>
                                    {/*找样剩余 {item.remainderDays||'0'} 天*/}
                                    {__getServerLanguage('ZhaoYangShengYuTian',item.remainderDays||'0')}
                                </span>
                            </div>
                            :
                            null
                    }

                </div>
            </div>;
        }
    }

    render(){
        const {item = {}} = this.props;
        const  {buyerVO = {}} = item;
        let file = {};
        if(item.fileList&&item.fileList.length>0){
            file = item.fileList[0];
        }
        return (
            <div className="task-item__wrap">
                <div className="item" onClick={this.openDetail.bind(this,item)}>
                    <div className="flex-box">
                        {
                            file.url?
                                <img src={file.url} className="img" alt=""/>
                                :
                                <img src="http://oss.essa.cn/04d1ca90-811f-4d61-96d4-ada86e4bfedb.svg" className="img" alt=""/>
                        }
                        <div className="flex-1 lineH_150p overflow-hidden">
                            <div className="name mb_4" title={item.subject||'-'}>{item.subject||'-'}</div>
                            <div className="color089 font_14 fw_700 mb_4">
                                <span className="mr_8">{buyerVO.code}</span>
                                <span>{buyerVO.countryName}</span>
                            </div>
                            <div className="color066 font_14">
                                <span className="mr_12">{item.createTime?dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</span>
                                <span>#{item.id}</span>
                            </div>
                        </div>
                    </div>
                    <div className="mt_12">
                        {this.getFooterHtml(item)}
                    </div>
                </div>
            </div>
        )
    }
}

Item.defaultProps = {
    item:{},
    extra:{}
}

Item.propTypes = {

}
export default Item;
